/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     File            :   useCanViewCost.ts
 *     Description     :   Single source of truth for the owner directive "only show cost to
 *                         admin and manager". Any $ / spend / billing figure in the app is
 *                         gated behind this — hide the cost element for Viewers, keep the
 *                         surrounding non-cost content visible. Case-insensitive (the runtime
 *                         role is PascalCase 'Admin'/'Manager'; the store normalizes).
 *     Author          :   Peter Dobler
 * =========================================================================================
 */
import { useAuthStore } from '../stores/authStore';
import { roleSatisfies } from '@shared/access/roles';

/**
 * True for Admin / Manager — the roles allowed to see cost / spend figures — and SuperAdmin
 * (Spec 285: SuperAdmin ⊇ Admin; it was refused here, hiding cost from the strongest role).
 */
export function useCanViewCost(): boolean {
  const user = useAuthStore((s) => s.user);
  return roleSatisfies(user?.role, ['Admin', 'Manager']);
}
